export default function NewsletterForm() {
  const formWrappers = document.querySelectorAll('.newsletter-form-wrapper');

  formWrappers.forEach(wrapper => {
    const newsletterForms = wrapper.querySelectorAll('.newsletter-form');
    const nextButton = wrapper.querySelector('.newsletter-form__next');
    const goBackButton = wrapper.querySelector('.newsletter-form__go-back');
    const accordionItems = wrapper.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
      const titleWrapper = item.querySelector('.accordion-title-wrapper');
      titleWrapper.addEventListener('click', () => {
        // Close previously opened accordion within this form
        const openAccordion = wrapper.querySelector('.accordion-item.open');
        if (openAccordion && openAccordion !== item) {
          openAccordion.classList.remove('open');
        }

        // Toggle current accordion
        item.classList.toggle('open');
      });
    });

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        handleNextStep(wrapper);
      });
    }

    if (goBackButton) {
      goBackButton.addEventListener('click', () => {
        handlePreviousStep(wrapper);
      });
    }
  });

  function handleNextStep(wrapper) {
    const currentStep = wrapper.querySelector('.newsletter-form--step.active');
    const nextStep = currentStep.nextElementSibling;
    if (nextStep) {
      currentStep.classList.remove('active');
      nextStep.classList.add('active');
    }
  }

  function handlePreviousStep(wrapper) {
    const currentStep = wrapper.querySelector('.newsletter-form--step.active');
    const previousStep = currentStep.previousElementSibling;
    if (previousStep) {
      currentStep.classList.remove('active');
      previousStep.classList.add('active');
    }
  }
}
